import { Box, Typography, useTheme } from '@mui/material';
import { getSummarySegmentTextColor } from '../utils/orderItem/helpers';
import type { OrderItemSummarySegment } from '../utils/orderItem/types';

interface SummarySegmentsProps {
  segments: OrderItemSummarySegment[];
}

export function SummarySegments({ segments }: SummarySegmentsProps) {
  const theme = useTheme();

  return segments.map((segment) => (
    <Typography
      key={segment.label}
      variant="caption"
      color="text.secondary"
      display="block"
    >
      {segment.label}:{' '}
      <Box
        component="span"
        fontWeight={600}
        sx={{
          color:
            getSummarySegmentTextColor(theme, segment.colorHex) ??
            'text.primary',
        }}
      >
        {segment.parts.join(' • ')}
      </Box>
    </Typography>
  ));
}
